<script setup lang="ts">
import FaIcon from '@/application/components/ui/FaIcon.vue';
import MaklervollmachtModal from "@/Maklervollmacht/components/MaklervollmachtModal.vue";
import { ref } from "vue";
import { useBaseDataStore } from '@/user/store/baseDataStore.ts';

const { duzen } = useBaseDataStore();
const show = ref(false);
</script>

<template>
  <div class="bg-blue-100/70 z-50 ring-hairline py-3">
    <MaklervollmachtModal v-model:show="show" />
    <div class="container flex flex-row items-center gap-3 text-sm md:text-base text-blue-800">
      <FaIcon
        name="circle-info"
        variant="light"
      />
      <span>
        Es liegt noch kein Maklervertrag bzw. -vollmacht vor. Diesen {{ duzen('kannst du', 'können Sie') }}
        <span class="font-semibold underline cursor-pointer" @click="show = true">jetzt anfordern und unterschreiben</span>.
      </span>
    </div>
  </div>
</template>
